import { client } from '../default.client';

export interface RegisterTokenOptions {
	analyticDeviceID: string;
	token: string;
	XOS: string;
	XProject: string;
}

export interface SendPushEventOptions extends RegisterTokenOptions {
	notificationId: string;
}

export interface LiveActivitySessionAttributes {
	activity_id: string;
	activity_token: string;
	fcm_token?: string;
	order_id: string;
	project: string;
	user_id: number;
}

interface RegisterTokenRequest {
	data: {
		attributes: {
			analyticDeviceID: string;
			token: string;
		};
	};
}

const buildRegisterBody = (
	options: RegisterTokenOptions
): RegisterTokenRequest => {
	const { analyticDeviceID, token } = options;

	return {
		data: {
			attributes: {
				analyticDeviceID,
				token
			}
		}
	};
};

export const pushGateway = {
	registerToken(options: RegisterTokenOptions): Promise<void> {
		const body = buildRegisterBody(options);

		return client.post('/api/v2/push-gateway/token', body, {
			headers: {
				'X-OS': options.XOS,
				'X-Project': options.XProject
			}
		});
	},

	unregisterToken(token: string): Promise<void> {
		return client.post('/api/v2/push-gateway/token/un-assign', {
			data: {
				attributes: {
					token
				}
			}
		});
	},

	sendPushEvent(options: SendPushEventOptions): Promise<void> {
		return client.post(
			`/push-gateway/v1/notifications/${options.notificationId}/open`,
			{
				analytic_device_id: options.analyticDeviceID,
				opened_at: new Date().toISOString(),
				project: options.XProject,
				token: options.token
			}
		);
	},

	registerLiveActivitySession(
		data: LiveActivitySessionAttributes
	): Promise<void> {
		return client.post('/push-gateway/v2/live-activity/sessions', {
			data: {
				attributes: data,
				type: 'live-activity-session'
			}
		});
	}
};
